import React, { useEffect, useState } from "react";
import { Editor, EditorTools } from '@progress/kendo-react-editor';
import TagTool from './TagTool.jsx';
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  Undo,
  Redo,
  FontSize,
  FontName,
  FormatBlock,
  Link,
  Unlink,
  InsertImage,
  ViewHtml,
  InsertTable,
  AddRowBefore,
  AddRowAfter,
  AddColumnBefore,
  AddColumnAfter,
  DeleteRow,
  DeleteColumn,
  DeleteTable,
  MergeCells,
  SplitCell,
} = EditorTools;

export const SBAEditor = (props) => {
    const { onChange, defaultContent, editorHeight, setContent,showTagTool, ...rest } = props;
    const [value, setValue] = useState(defaultContent === undefined ? "" : defaultContent);
    useEffect(() => {
        setValue(defaultContent == undefined ? "" : props.defaultContent);
    }, [defaultContent]);
  const SBAEditorValueChanged=(e)=>{
    if(e && onChange)
    {
        setContent(e.html);
        setValue(e.html)
      onChange(e);
    }
  }
  const tagToolSetting=showTagTool ? [TagTool] :[ ];
  return (
    <div>
       <Editor
      tools={[
        [Bold, Italic, Underline, Strikethrough],
        [Subscript, Superscript],
        [AlignLeft, AlignCenter, AlignRight, AlignJustify],
        [Indent, Outdent],
        [OrderedList, UnorderedList],
        
        [Undo, Redo],
        [Link, Unlink, InsertImage, ViewHtml],
        [InsertTable],
        [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
        [DeleteRow, DeleteColumn, DeleteTable],
        [MergeCells, SplitCell], [...tagToolSetting]]}
      contentStyle={{
        height: editorHeight,
      }}
              value={value}
      onChange={SBAEditorValueChanged}
      {...rest}
    />
    </div>
  );
};